<template>
  <v-navigation-drawer :value="value" app clipped floating class="shadow" @input="onInput">
    <v-card color="#E0F6FF" class="caption fill-height inherit-color">
      <v-list dense class="custom-text">
        <div v-for="(item, index) in listItems" :key="index + item.name">
          <v-divider v-if="item.surrounded" />
          <v-layout row wrap align="center">
            <v-list-item
              active-class="active-class"
              class="custom-text body-2"
              :class="item.class"
              height="30"
              :style="getStyle(item.level)"
              :to="item.routerLink"
              :inactive="!item.routerLink"
            >
              <v-list-item-icon
                v-if="item.icon"
                :class="item.icon && item.outlined ? 'outlined' : ''"
              >
                <template v-if="item.outlined">
                  <v-btn icon outlined small height="35" width="35">
                    <v-icon
                      size="17"
                      v-text="item.icon"
                      class="custom-text"
                      :class="item.iconClass"
                      style="width: 17px"
                    />
                  </v-btn>
                </template>
                <v-icon
                  v-else
                  size="17"
                  v-text="item.icon"
                  class="custom-text"
                  style="width: 17px"
                />
              </v-list-item-icon>
              <v-list-item-content>{{ item.name }}</v-list-item-content>
            </v-list-item>
          </v-layout>
          <v-divider v-if="item.surrounded" />
          <v-slide-x-transition>
            <template v-if="item.children && $route.path.includes(item.routerLink.name)">
              <v-list dense class="littlePadding">
                <div>
                  <v-list-item
                    v-for="(subItem, key) in item.children"
                    active-class="sub-active-class"
                    :key="subItem.name + key"
                    :style="getStyle(item.level + 2)"
                    :to="subItem.routerLink"
                  >
                    <v-list-item-content>{{ subItem.name }}</v-list-item-content>
                  </v-list-item>
                </div>
              </v-list>
            </template>
          </v-slide-x-transition>
        </div>
      </v-list>
    </v-card>
  </v-navigation-drawer>
</template>
<script>
/* eslint-disable no-console */
export default {
  name: "navigation",
  props: {
    value: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      listItems: [
        {
          icon: "$vuetify.icons.appMenu",
          name: "Modules",
          class: "body-1 font-weight-semibold my-2",
          routerLink: { name: "modules" },
          outlined: true,
        },
        {
          icon: "$vuetify.icons.appFlipchart2",
          name: "Lessons",
          surrounded: true,
          level: 1,
          class: "body-1 font-weight-semibold my-2",
          outlined: true,
          routerLink: { name: "lessons" },
        },
        {
          name: this.$store.getters["modules/selectedModule"].name,
          class: "font-weight-bold my-6",
          level: 0.00001,
        },
        {
          icon: "$vuetify.icons.appFlipchart",
          name: this.$store.getters["modules/currentLesson"].name,
          routerLink: { name: "teacher-lesson" },
          class: "height-reduced",
          level: 0.0001,
        },
        {
          icon: "$vuetify.icons.appFlipchart2",
          name: "Lesson Practice",
          level: 1.6,
          routerLink: { name: "practice" },
        },
        {
          icon: "$vuetify.icons.appGrammar",
          name: "Sentence Structure",
          level: 1.6,
          routerLink: { name: "grammar" },
          children: this.$store.getters["lesson/grammar"].exercises.map((element, index) => ({
            name: `Exercise ${index + 1}`,
            routerLink: { name: "exercise", params: { index: index + 1 } },
          })),
        },
        {
          icon: "$vuetify.icons.appProgress",
          name: "My Progress",
          surrounded: true,
          class: "my-1",
          routerLink: { name: "progress" },
          level: 0.0001,
        },
        {
          name: "Support",
          class: "font-weight-medium text-uppercase mt-10 mb-2",
          disabled: true,
        },
        {
          icon: "$vuetify.icons.appLetter",
          name: "Contact Us",
          routerLink: { name: "contactUs" },
          level: 0.1,
        },
        {
          icon: "mdi-cloud",
          iconClass: "mt-n2",
          name: "Arches Cloud",
          routerLink: { name: "cloud" },
          level: 0.1,
        },
      ],
    };
  },
  methods: {
    getStyle(level) {
      return "padding-left: " + String(40 + level * 20) + "px;";
    },
    onInput(e) {
      this.$store.commit("modules/toggleDrawer", e);
    },
  },
  created() {
    if (this.$store.getters["profile"].role === "TEACHER") {
      this.listItems.splice(7, 1, {
        name: "Restart Progress",
        routerLink: { name: "restore" },
        level: 0.0001,
        class: "my-2",
      });
    }
    let progress = this.$store.getters["progress/lesson"];
    if (!progress.grammar_progress) {
      const index = this.listItems.findIndex((element) => element.name === "Sentence Structure");
      this.listItems.splice(index, 1);
    }
    if (!progress.practice_progress) {
      const index = this.listItems.findIndex((element) => element.name === "Lesson Practice");
      this.listItems.splice(index, 1);
    }
  },
};
</script>
<style scoped>
.custom-text {
  color: #29284c;
}
.v-list-item {
  padding-left: 30px;
  height: 30px;
  min-height: 30px !important;
}
.v-list-item__icon {
  margin-right: 6px !important;
}
.v-list-item__icon.outlined {
  margin-top: 2px !important;
  margin-right: 6px !important;
}
.active-class {
  background-color: #0000ca;
  opacity: 1;
  color: white !important;
}
.sub-active-class {
  background-color: #c6eeff !important;
  font-weight: 800;
}
.littlePadding {
  padding-top: 2px !important;
}
.v-btn {
  margin-top: -5px !important;
  border: 1px solid #29274d2c;
}
.height-reduced {
  line-height: 0.85rem !important;
}
</style>
